module.exports = __webpack_public_path__ + "static/media/22ESCWA13.3c7b2a97.jpg";